import sk from "../lang/sk/sk.json"
import en from "../lang/en/en.json"

export default { sk, en };